module.exports = "/_next/static/images/bf46dd31cfb01698ba416f639dc6a8f0-coin.svg.webp";